import { Check } from "lucide-react";
import { Reveal } from "./Reveal";
import { EUR } from "@/lib/api";

export const PACKS = [
    {
        id: "pack-1",
        lookupKey: "coussin_1x",
        name: "1x Coussin Ergocox™",
        tagline: "Pour votre bureau principal",
        price: 49.9,
        original: 69.9,
        badge: "Standard",
        features: ["1 Coussin Ergocox™", "Housse lavable offerte", "Garantie 2 ans"],
    },
    {
        id: "pack-2",
        lookupKey: "coussin_2x",
        name: "2x Pack Duo (Bureau + Voiture)",
        tagline: "Le choix le plus populaire",
        price: 89.8,
        original: 139.8,
        discount: "-10%",
        badge: "Le Plus Vendu",
        popular: true,
        features: ["2 Coussins Ergocox™", "2 Housses lavables offertes", "Assistance dédiée 7j/7", "Garantie VIP 5 ans"],
    },
    {
        id: "pack-3",
        lookupKey: "coussin_3x",
        name: "3x Pack Famille / Entreprise",
        tagline: "Pour toute la maison ou l’équipe",
        price: 127.2,
        original: 209.7,
        discount: "-15%",
        badge: "Meilleure Offre",
        features: ["3 Coussins Ergocox™", "3 Housses lavables offertes", "Sac de transport offert", "Garantie VIP à vie"],
    },
];

export default function Packs({ onSelect }) {
    return (
        <section id="offres" className="py-20 lg:py-32 bg-sand/40 scroll-mt-20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
                <Reveal className="text-center max-w-2xl mx-auto">
                    <p className="text-xs uppercase font-mono tracking-[0.25em] text-sage-mid">Offres de lancement</p>
                    <h2 className="mt-5 font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight text-ink">
                        Choisissez Votre Pack Confort
                    </h2>
                    <p className="mt-4 text-base text-[#4A5550]">
                        Livraison Suivie Offerte — 8 à 12 jours en France Métropolitaine
                    </p>
                </Reveal>
                <div className="mt-12 lg:mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 items-stretch">
                    {PACKS.map((p, i) => (
                        <Reveal key={p.id} delay={i * 0.1} className="h-full">
                            <div
                                data-testid={`pack-selector-${i + 1}`}
                                className={`relative h-full rounded-[1.75rem] border p-6 sm:p-8 lg:p-10 flex flex-col transition-all duration-300 ${
                                    p.popular
                                        ? "bg-sage text-cream border-sage shadow-2xl shadow-sage/30 md:-translate-y-3"
                                        : "bg-white border-sage/15 hover:border-sage hover:shadow-xl hover:shadow-sage/15"
                                }`}
                            >
                                <span
                                    className={`absolute -top-3 left-1/2 -translate-x-1/2 rounded-full px-4 py-1 text-[11px] font-mono uppercase tracking-[0.15em] ${
                                        p.popular ? "bg-terra text-white" : "bg-sage-soft text-sage"
                                    }`}
                                >
                                    {p.badge}
                                </span>
                                <h3 className={`mt-4 font-serif text-2xl ${p.popular ? "text-cream" : "text-ink"}`}>{p.name}</h3>
                                <p className={`mt-1 text-sm ${p.popular ? "text-cream/70" : "text-[#4A5550]"}`}>{p.tagline}</p>
                                <div className="mt-6 flex items-end gap-3">
                                    <span data-testid={`pack-price-${i + 1}`} className="font-serif font-bold text-4xl lg:text-[2.6rem] leading-none">
                                        {EUR(p.price)}
                                    </span>
                                    <span className={`text-lg line-through mb-0.5 ${p.popular ? "text-cream/50" : "text-ink/35"}`}>
                                        {EUR(p.original)}
                                    </span>
                                </div>
                                {p.discount && (
                                    <span className="mt-3 self-start rounded-full bg-terra-soft text-terra px-3 py-1 text-xs font-bold">
                                        {p.discount} — économisez {EUR(p.original - p.price)}
                                    </span>
                                )}
                                <ul className={`mt-7 flex flex-col gap-3 text-sm ${p.popular ? "text-cream/85" : "text-ink/75"}`}>
                                    {p.features.map((f, j) => (
                                        <li key={j} className="flex items-start gap-2.5">
                                            <span className={`mt-0.5 w-4.5 h-4.5 shrink-0 rounded-full grid place-items-center ${p.popular ? "bg-cream/15 text-cream" : "bg-sage-soft text-sage"}`}>
                                                <Check size={12} strokeWidth={3} />
                                            </span>
                                            {f}
                                        </li>
                                    ))}
                                </ul>
                                <button
                                    data-testid={`pack-buy-button-${i + 1}`}
                                    onClick={() => onSelect(p)}
                                    className={`mt-8 w-full rounded-full py-4 text-sm font-semibold transition-all duration-300 hover:scale-[1.02] hover:shadow-lg ${
                                        p.popular
                                            ? "bg-cream text-sage hover:bg-white"
                                            : "bg-sage text-cream hover:bg-sage-hover"
                                    }`}
                                >
                                    Commander — {EUR(p.price)}
                                </button>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
